import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-681364ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "avatar" }
const _hoisted_2 = {
  key: 3,
  class: "onLine"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "messageRightBox" }
const _hoisted_5 = { class: "nameBox" }
const _hoisted_6 = {
  key: 0,
  class: "name"
}
const _hoisted_7 = {
  key: 1,
  class: "name"
}
const _hoisted_8 = { class: "time" }
const _hoisted_9 = { class: "subTitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_badge = _resolveComponent("van-badge")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!$setup.data.isGroup)
        ? (_openBlock(), _createBlock(_component_van_image, {
            key: 0,
            round: "",
            width: "50",
            fit: "cover",
            height: "50",
            src: $setup.data.headurl
          }, null, 8 /* PROPS */, ["src"]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "gropAvatar",
            style: _normalizeStyle({ 'height': '50px', 'color': '#fff', 'width': '50px', 'background-color': $setup.data.bgc || '#9fdb5c' })
          }, _toDisplayString($setup.data.headurl), 5 /* TEXT, STYLE */)),
      ($setup.data.red !== 0)
        ? (_openBlock(), _createBlock(_component_van_badge, {
            key: 2,
            content: $setup.data.red,
            max: "99"
          }, null, 8 /* PROPS */, ["content"]))
        : _createCommentVNode("v-if", true),
      ($setup.online)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("v-if", true),
      _createCommentVNode("主播或者管理员icon"),
      ($setup.data.isGroup == false && $setup.cellUser && ($setup.cellUser.usertype ==1 || $setup.cellUser.usertype ==2))
        ? (_openBlock(), _createElementBlock("img", {
            key: 4,
            src: $setup.setHostIcon($setup.cellUser),
            class: "host-icon-class"
          }, null, 8 /* PROPS */, _hoisted_3))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        ($setup.data.nickname)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.data.nickname), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('im.group')), 1 /* TEXT */)),
        _createElementVNode("div", _hoisted_8, _toDisplayString($setup.IMformatDate($setup.data.time)), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_9, _toDisplayString($setup.msgtypecontent($setup.data)), 1 /* TEXT */),
      _createCommentVNode(" <div class=\"rightTime\">\n             \n            </div> ")
    ])
  ], 64 /* STABLE_FRAGMENT */))
}